import * as React from 'react';
import Button from '../../../../../../components/common/Button';
import { downloadFile } from 'src/utils/downloadHelper';
import './BoxConfirm.scss';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import ShippingLabelToPrint from '../ShippingLabelToPrint';
import ReactToPrint from 'react-to-print';
import localeFormatingInstance from 'src/translation/localeFormating';

interface IBoxConfirm {
  distributionSelectedOption: string;
  handleDistributionChangeOption: (e: any) => void;
  rmaSelected: string;
  handleGenerateShippingLabel:(e:any,toShippingWarehouseCode:string)=>void;
  boxResponseData:any[];
  totalShippingCharge:number;
  handleConfirmationCancel: (e:any)=>void;
  handleUpsConfirmation: (e:any)=>void;
  shippingType:string;
  totalItemPrice:number;
  t?: any;
}
const BoxConfirm: React.FC<IBoxConfirm> = props => {
  const {
    rmaSelected,
    distributionSelectedOption,
    handleDistributionChangeOption,
    handleGenerateShippingLabel,
    boxResponseData,
    totalShippingCharge,
    handleConfirmationCancel,
    handleUpsConfirmation,
    shippingType,
    totalItemPrice,
    t
  } = props;

  const componentRef = React.useRef();
  const[labelSignleImage, setLabelSignleImage]= React.useState<any>([]); 
  const [isDownloadingDetails, setIsDownloadingDetails] = React.useState<boolean>(false);
  const [documentTitle, setDocumentTitle] = React.useState<string>('');

  const downloadPdf=(imageLink:string)=>{
    console.log("==== Clicked ====");
     setLabelSignleImage(imageLink);
  }

   const getEstimatedRefundAmount = () => {
    const refundSAmout=totalItemPrice-totalShippingCharge;
    return refundSAmout;
  };
  const estimatedRefundAmout=getEstimatedRefundAmount();

  return (
    <div className="rp-returns-table">
      <div style={{ display: 'none' }}>
        <ShippingLabelToPrint
          ref={componentRef}
          shippingLabel={boxResponseData}
        />
      </div>
     
      <div className="rp-returns-table-row-container">
        {/* Rows here */}
      
      {boxResponseData.map((res, i) => ( 
      <div className="rp-returns-row" key={i}>
      <div className="container-fluid">
        <div className="mobile--box-row">


        <div className="d-flex align-items-center-box col-12">
            <p className="rp-returns-box-mobile-table-header">{t('myReturns.boxNo')} </p>
              <p className="rp-returns-box-mobile-row-container">
               <div className="box-shipping-container">
               <div>
                  <div className='dropdown-container'>
                  {i+1}
                  </div>  
               </div>
            </div>
              </p>
         </div>
          

         <div className="d-flex align-items-center-box  col-12">

          <p className="rp-returns-box-mobile-table-header">{t('myReturns.dimensionMobile')}</p>  
          <p className="rp-returns-box-mobile-row-container">

            <div className="box-shipping-container">
            <div>
            <div className='dropdown-container'>
              <div><label className='boxLeft'><strong>{res.boxLength}</strong> Inch</label>
                
              </div>
            </div> 
            </div>
            <div>
            <div className='dropdown-container'>
              <div>
                <label className='boxLeft'><strong>{res.boxWidth}</strong> Inch</label>
                  
              </div>
                  
            </div> 
            </div>
            <div>
            <div className='dropdown-container'>
              <div>
              <label className='boxLeft'><strong>{res.boxHeight}</strong> Inch</label>
              
              </div>
            </div> 
            </div>
            </div>
          </p>
          </div> 


          <div className="d-flex align-items-center-box  col-12">
            <p className="rp-returns-box-mobile-table-header">
                {t('myReturns.weight')}
              </p>  
              <p className="rp-returns-box-mobile-row-container">
              <div className="box-shipping-container">
                <div>
                  <div className='dropdown-container'>
                    <div>
                        <label className='boxLeft'><strong>{res.boxWeight}</strong> Lb</label>
                      </div>
                  </div>  

                </div>
              </div>
              </p>
          </div>


          <div className="d-flex align-items-center-box  col-12">
            <p className="rp-returns-box-mobile-table-header">
               Price
              </p>  
              <p className="rp-returns-box-mobile-row-container">
              <div className="box-shipping-container">
                <div>
                  <div className='dropdown-container'>
                    <div>
                        <label className='boxLeft'><strong>{currencyFormatter(res.price)}</strong> Lb</label>
                      </div>
                  </div>  

                </div>
              </div>
              </p>
          </div>

        </div>
      </div>
    </div>
     ))}
        {/* End Rows here */}
        <p>&nbsp;</p>  
        <div className="d-flex align-items-center-box col-12">
          <p><strong>Total Shipping Charge {currencyFormatter(totalShippingCharge)}</strong></p>
        </div>

        <div className="d-flex align-items-center-box col-12">
          <p><strong>Estimated Refund Amount {currencyFormatter(estimatedRefundAmout)}</strong></p>
        </div>

        

        <div className="d-flex align-items-center col-12">
        {isDownloadingDetails && (
            <div className="rp-box-confirm-desktop-loading">
              <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                <div className="ldio-9coovtt1mti">
                  <div />
                </div>
              </div>
            </div>
          )}
          <p className="confirm-box-shipping-label">

          <ReactToPrint
              onBeforeGetContent={() => {
                setDocumentTitle(document.title);
                document.title = `Shipping-Label-${localeFormatingInstance.getNowDate('short')}.pdf`;
                setIsDownloadingDetails(true);
                setLabelSignleImage(boxResponseData);
              }}
              onAfterPrint={() => {
                document.title = documentTitle;
                setIsDownloadingDetails(false);
              }}
              trigger={() => (
                <div
                  className={`rp-box-confirm-desktop-print ${isDownloadingDetails &&
                    'disabled'}`}
                >
                  <i className="rpds-print" />
                  <p>Print Shipping Lables</p>
                </div>
              )}
              content={() => componentRef.current}
            />


          </p>
        </div>

      </div>
      <p>&nbsp;</p>  
      <div className="container-fluid">
      <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('myReturns.cancel')}
            action={handleConfirmationCancel}
            disabled={shippingType==="PREPAID_SHIPPING"? true:false}
          />
        </button>  
      <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('myReturns.confirm')}
            action={handleUpsConfirmation}
            disabled={shippingType==="PREPAID_SHIPPING"? true:false}
          />
        </button>
      </div>
    </div>
   
  );
};

export default BoxConfirm;
